import React, { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Form, Button } from "react-bootstrap";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {
  AddMoneyReason,
  RemoveMoneyReason,
} from "../../../../enums/DropDownDataTable";

import {
  InputLabel,
  TextField,
  FormControl,
  Select,
  MenuItem,
  makeStyles,
} from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import isEmpty from "../../../../store/validation/is-Empty";
import { admin_add_money_user_wallet } from "../../../../store/actions/SuperAdminActions/superAdminWalletAction";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import Alert from "react-s-alert";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

function SuperAdminUserWallet(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [state, setState] = useState(0);
  const addMoneyState = () => {
    setState(0);
    formik.setFieldValue("balance", "");
    formik.setFieldValue("reason", "");
    formik.setFieldValue("comment", "");
    formik.setFieldTouched("balance", false, false);
    formik.setFieldTouched("reason", false, false);
    formik.setFieldTouched("comment", false, false);
    formik.setFieldValue("notify", false);
  };
  const removeMoneyState = () => {
    setState(1);
    formik.setFieldValue("balance", "");
    formik.setFieldValue("reason", "");
    formik.setFieldValue("comment", "");
    formik.setFieldTouched("balance", false, false);
    formik.setFieldTouched("reason", false, false);
    formik.setFieldTouched("comment", false, false);
    formik.setFieldValue("notify", false);
  };
  const [errors, setErrors] = useState("");

  const token = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth : "";
  });

  useEffect(() => {
    axios
      .get("https://ipapi.co/json")
      .then((result) =>
        formik.setFieldValue(
          "user_country_code",
          result.data.country_calling_code
        )
      )
      .catch((error) => setErrors(error));
    dispatch(clear_all_errors());
  }, []);

  const onNotifyChange = () => {
    formik.setFieldValue("notify", !formik.values.notify);
  };

  const handleChangeCode = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };

  const formik = useFormik({
    initialValues: {
      credit: true,
      debit: true,
      balance: "",
      user_country_code: "",
      user_mobile_number: "",
      departmentalCode: "SP101",
      reason: "",
      comment: "",
      notify: false,
    },
    validationSchema: yup.object({
      user_mobile_number: yup
        .string()
        .required("Phone number is required")
        .matches(phoneRegExp, "Phone number is not valid")
        .min(10, "to short")
        .max(10, "to long"),
      balance: yup.string().required("Amount is required"),
      // .min(50, "minimum amount is 50"),
      departmentalCode: yup.string().required("Departmental Code is required"),
      reason: yup.string().required("Reason is required"),
      comment: yup.string().required("Comment is required"),
    }),

    onSubmit: (values) => {
      var formData = {};
      if (state === 0) {
        formData.credit = values.credit;
      } else {
        formData.debit = values.debit;
      }
      formData.user_country_code = values.user_country_code;
      formData.user_mobile_number = values.user_mobile_number.toString();
      formData.balance = values.balance;
      formData.departmentalCode = values.departmentalCode;
      formData.reason = values.reason;
      formData.comment = values.comment;
      formData.notify = values.notify;
      dispatch(
        admin_add_money_user_wallet(
          token.user.accessToken,
          formData,
          onSuccess,
          (err) => onError(err)
        )
      );
    },
  });

  const onSuccess = () => {
    Alert.success(`<h4>Request Send Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/superadmin/userwallet/addremovemoneyrequest");
  };

  const onError = (err) => {
    Alert.error(`<h4>${err.response.data.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  // for set focus
  useEffect(() => {
    if (formik.errors && formik.errors.user_mobile_number) {
      let user_mobile_numberElement =
        document.getElementById("user_mobile_number");
      user_mobile_numberElement.focus();
    } else if (formik.errors && formik.errors.balance) {
      let balanceElement = document.getElementById("balance");
      balanceElement.focus();
    } else if (formik.errors && formik.errors.reason) {
      let reasonElement = document.getElementById("reason");
      reasonElement.focus();
    } else if (formik.errors && formik.errors.departmentalCode) {
      let departmentalCodeElement = document.getElementById("departmentalCode");
      departmentalCodeElement.focus();
    } else if (formik.errors && formik.errors.comment) {
      let commentElement = document.getElementById("comment");
      commentElement.focus();
    }
  }, [count]);

  if (token?.secondary_loader) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div className="super-admin-inside-right-side-panel">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                  <div className="f24_700_HelveticaNeue">Add/Remove Money</div>
                </div>
                <div className="mt-2 mb-3">
                  <div className="row">
                    <div className="col-6">
                      <div className="d-flex justify-content-between">
                        <div
                          onClick={addMoneyState}
                          style={{
                            color: state === 0 ? "#EE3A23" : "#9E9E9E",
                            borderBottom:
                              state === 0 ? "1px solid #EE3A23" : "",
                            cursor: "pointer",
                          }}
                        >
                          Add Money to Users Wallet
                        </div>
                        <div
                          onClick={removeMoneyState}
                          style={{
                            color: state === 1 ? "#EE3A23" : "#9E9E9E",
                            borderBottom:
                              state === 1 ? "1px solid #EE3A23" : "",
                            cursor: "pointer",
                          }}
                        >
                          Remove Money from Users Wallet
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-5 mb-3">
                  <div className="row">
                    <div className="col-5">
                      <Form.Row className="input-component-insideRow mb-2">
                        <div className="col-4 col-xl-3 pr-0">
                          <Form.Group controlId={"country_code"}>
                            <div className="input-phone-country-code-reusable w-100">
                              <select
                                id="user_country_code"
                                name="user_country_code"
                                value={formik.values.user_country_code}
                                onChange={formik.handleChange}
                                className="w-100"
                              >
                                <option value={formik.values.user_country_code}>
                                  {formik.values.user_country_code}
                                </option>
                                {getCountries().map((country) => (
                                  <option
                                    key={country}
                                    value={"+" + getCountryCallingCode(country)}
                                  >
                                    {en[country]} (+
                                    {getCountryCallingCode(country)})
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Form.Group>
                        </div>
                        <div className="col-8 col-xl-9">
                          <Form.Group>
                            <TextField
                              id="user_mobile_number"
                              label="Phone Number"
                              type="number"
                              variant="outlined"
                              className={`w-100 ${
                                formik.errors.user_mobile_number &&
                                formik.touched.user_mobile_number
                                  ? "enError"
                                  : ""
                              }`}
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 10);
                              }}
                              name="user_mobile_number"
                              onChange={formik.handleChange}
                              value={formik.values.user_mobile_number}
                              onBlur={formik.handleBlur}
                              // isInvalid={
                              //   formik.errors.user_mobile_number &&
                              //   formik.touched.user_mobile_number
                              // }
                            />
                            {formik.errors.user_mobile_number &&
                            formik.touched.user_mobile_number ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.user_mobile_number}
                              </div>
                            ) : null}
                          </Form.Group>
                        </div>
                      </Form.Row>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-5 mt-2">
                      <Form.Group className="mb-2">
                        <TextField
                          id="balance"
                          label="Enter Amount"
                          type="number"
                          variant="outlined"
                          className={`w-100 ${
                            formik.errors.balance && formik.touched.balance
                              ? "enError"
                              : ""
                          }`}
                          onInput={(e) => {
                            e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 6);
                          }}
                          name="balance"
                          onChange={formik.handleChange}
                          value={formik.values.balance}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.balance && formik.touched.balance ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.balance}
                          </div>
                        ) : null}
                      </Form.Group>
                      {state === 0 ? (
                        <div
                          className="f10-400 mt-2 mb-4"
                          style={{ color: "#9E9E9E" }}
                        >
                          *The amount more than Rs 5000/- will be credited to
                          account only. The amount ranging from Rs 50/- to Rs
                          5000/- can be credited to the wallet.
                        </div>
                      ) : (
                        <div
                          className="f10-400 mt-2 mb-4"
                          style={{ color: "#9E9E9E" }}
                        >
                          The amount should be minimum Rs 10/- and maximum Rs
                          500/-
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-5 mt-2 mb-2">
                      <Form.Group>
                        <TextField
                          id="departmentalCode"
                          label="Department Code"
                          type="text"
                          variant="outlined"
                          className={`w-100 ${
                            formik.errors.departmentalCode &&
                            formik.touched.departmentalCode
                              ? "enError"
                              : ""
                          }`}
                          inputProps={{
                            maxLength: 32,
                          }}
                          name="departmentalCode"
                          onChange={formik.handleChange}
                          value={formik.values.departmentalCode}
                          onBlur={formik.handleBlur}
                          disabled={true}
                        />
                        {formik.errors.departmentalCode &&
                        formik.touched.departmentalCode ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.departmentalCode}
                          </div>
                        ) : null}
                      </Form.Group>
                    </div>{" "}
                  </div>
                  <div className="row">
                    <div className="col-5 mt-2 mb-2">
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <InputLabel htmlFor="outlined-time">
                          {state === 0 ? "Add" : "Remove"} Reason
                        </InputLabel>
                        <Select
                          value={formik.values.reason}
                          onChange={formik.handleChange}
                          label="Reservation Time"
                          inputProps={{
                            name: "reason",
                            id: "outlined-time",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <MenuItem value="" disabled selected>
                            Select Reason
                          </MenuItem>
                          {/* <MenuItem value={"Amount"}>Add Amount</MenuItem>
                          <MenuItem value={"Remove"}>Remove Amount</MenuItem> */}
                          {state === 0
                            ? AddMoneyReason &&
                              AddMoneyReason.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item.value}>
                                    {item.title}
                                  </MenuItem>
                                );
                              })
                            : RemoveMoneyReason &&
                              RemoveMoneyReason.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item.value}>
                                    {item.title}
                                  </MenuItem>
                                );
                              })}
                        </Select>
                        {formik.errors.reason && formik.touched.reason ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.reason}
                          </div>
                        ) : null}
                      </FormControl>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-5 mt-4 mb-2">
                      <Form.Group>
                        <TextField
                          id="comment"
                          label="Add Comments"
                          type="text"
                          variant="outlined"
                          multiline
                          rows={4}
                          className={`w-100 ${
                            formik.errors.comment && formik.touched.comment
                              ? "enError"
                              : ""
                          }`}
                          inputProps={{
                            maxLength: 512,
                          }}
                          name="comment"
                          onChange={formik.handleChange}
                          value={formik.values.comment}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.comment && formik.touched.comment ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.comment}
                          </div>
                        ) : null}
                      </Form.Group>
                    </div>{" "}
                  </div>
                  <div className="row">
                    <div className="col-12 d-flex align-items-center f11-500">
                      <input
                        id="notify"
                        name="notify"
                        type="checkbox"
                        onChange={onNotifyChange}
                        value={formik.values.notify}
                        className="mr-2"
                      />
                      Notify Customer By Push Notification
                    </div>
                    <div className="col-5 mt-2">
                      <br />
                      <div className="d-flex align-items-center">
                        <Button
                          variant="outline-secondary"
                          className="btn150px btn-lg mr-4 px-5"
                          type="button"
                          onClick={() => history.push("/superadmin/userwallet")}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="danger"
                          className="btn150px btn-lg px-5"
                          onClick={() => onClickSave()}
                          type="button"
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SuperAdminUserWallet;
